import { Button, ButtonGroup } from '@chakra-ui/react';
import { faArrowRotateLeft, faFileCirclePlus, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";

interface IDocumentRequestButtons {
  canRequest?: boolean;
  canDelete?: boolean;
  isDeleting?: boolean;
  canReset?: boolean;
  requestLabel?: string;
  deleteLabel?: string;
  onRequestClick?: () => void;
  onDeleteClick?: () => void;
  onResetClick?: () => void;
}

export const DocumentRequestButtons = (props: IDocumentRequestButtons) => {
    const { t } = useTranslation('common');
  const {
    canRequest,
    canDelete,
    isDeleting,
    canReset,
    requestLabel = 'Request custom document',
    deleteLabel = 'Delete document request',
    onRequestClick,
    onDeleteClick,
    onResetClick,
  } = props;

  return (
    <ButtonGroup
      display={'flex'}
      flexDirection={{ base: 'column', xl: 'row' }}
      spacing={0}
      columnGap={{ md: 3, xl: 4 }}
      rowGap={2}
      size={{ base: 'md', xl: 'lg' }}
      my={{ md: 10 }}
    >
      {canRequest && (
        <Button
          data-selector="custom-doc-request"
          onClick={onRequestClick}
          leftIcon={<FontAwesomeIcon icon={faFileCirclePlus} className="utility-icon" />}
          width={{ xl: '50%' }}
          flexShrink={1}
        >
          {requestLabel}
        </Button>
      )}

      {canDelete && (
        <Button
          data-selector="delete-document"
          onClick={onDeleteClick}
          isActive={isDeleting}
          colorScheme="red"
          leftIcon={<FontAwesomeIcon icon={faTrashAlt} className="utility-icon" />}
          width={{ xl: '50%' }}
          flexShrink={1}
        >
          {isDeleting ? 'Exit delete mode' : deleteLabel}
        </Button>
      )}

      {canReset && (
        <Button
          data-selector="resetQuestionnaire"
          onClick={onResetClick}
          leftIcon={<FontAwesomeIcon icon={faArrowRotateLeft} className="utility-icon" />}
          width={{ xl: '50%' }}
          flexShrink={1}
        >
          {t('common:resetQuestionnaire')}
                          </Button>
      )}
    </ButtonGroup>
  );
};
